import { render, staticRenderFns } from "./m-order-confirmation-template-card.vue?vue&type=template&id=3195c960&scoped=true&"
import script from "./m-order-confirmation-template-card.vue?vue&type=script&lang=js&"
export * from "./m-order-confirmation-template-card.vue?vue&type=script&lang=js&"
import style0 from "./m-order-confirmation-template-card.vue?vue&type=style&index=0&id=3195c960&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195c960",
  null
  
)

export default component.exports